import styles from "./preview.module.scss";
import { Col, Row } from "react-bootstrap";
import React, { useState, useEffect } from "react";

function useMobileFontSize() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
}

//import { AiFillBulb } from "react-icons/ai";

export const BodyTitle = ({ title }) => {
  return (
    <div className={styles.bodyTitle}>
      <h1>{title}</h1>
      <hr />
    </div>
  );
};

export const BodyDescCol = ({ data }) => {
  return (
    <div className={styles.bodyDescCol}>
      {Object.keys(data).map((el) => (
        <>
          <h2>{data[el].title}</h2>
          <Row>
            {data[el].list.map((item) => (
              <Col>
                <ul>
                  <li className={styles.listHead}>{item.title}</li>
                  {item.list.map((itemli) => (
                    <li>{itemli}</li>
                  ))}
                </ul>
              </Col>
            ))}
          </Row>
        </>
      ))}
    </div>
  );
};

export const BodyColList = ({ data, cols, noIcon, mobileFontSize }) => {
  const isMobile = useMobileFontSize();
  return (
    <div className={styles.bodyDescCol}>
      {Object.keys(data ?? {}).map((el) => (
        Array.isArray(data[el]?.list) && data[el].list.length > 0 &&
        <>
          <h2>{data[el].title}</h2>
          <Row>
            {data[el].list.map((item) => (
              <Col sm={12} md={cols}>
                <h5
                  className={styles.colListDesc}
                  style={{ 
                    ...(mobileFontSize && isMobile ? { fontSize: '14px' } : {}),
                    fontWeight: 600, 
                    fontSize: isMobile ? '14px' : '21px', 
                    display: 'flex', 
                    alignItems: 'flex-start' 
                  }}
                >
                  {!noIcon && (
                    <span style={{ marginRight: '10px', flexShrink: 0 }} role="img" aria-label="bulb">💡</span>
                  )}
                  <span style={{ display: 'block' }}>{item}</span>
                </h5>
              </Col>
            ))}
          </Row>
        </>
      ))}
    </div>
  );
};

export const BodySocial = ({ data }) => {
  return (
    <div className={styles.bodyDescCol}>
      <Row>
        <Col md={4}>
          {Object.keys(data).map((el) => (
            data[el].social.tag !== "" &&
            <>
              <h2>{data[el].title}</h2>
              <ul>
                <li>
                  <h5 className={styles.colListDesc}>{data[el].social.tag}</h5>
                  <h5 className={styles.colListDesc}>
                    {data[el].social.followers}
                  </h5>
                </li>
              </ul>
            </>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export const BodyList = ({ data }) => {
  return (
    <div className={styles.bodyDescCol}>
      <div>
        {Object.keys(data ?? {}).map((el) => (
          Array.isArray(data[el]?.list) && data[el].list.length > 0 && <>
            <h2>{data[el].title}</h2>

            <ul
              style={{
                listStyle: "none",
              }}
            >
              {data[el].list.map((item) => (
                <li style={{ position: 'relative' }}>
                  <h5
                    className={styles.colListDesc}
                    style={{
                      position: 'relative',
                      paddingLeft: '32px', // space for emoji
                      //textIndent: '-22px', // negative of emoji width + marginRight
                      fontWeight: 600,
                      fontSize: window.innerWidth <= 600 ? '12px' : '21px',
                      lineHeight: 1.5,
                    }}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '22px',
                        display: 'inline-block',
                        textAlign: 'center',
                        marginRight: '10px',
                        marginLeft: '0px',
                        flexShrink: 0,
                      }}
                      role="img"
                      aria-label="bulb"
                    >
                      💡
                    </span>
                    {item}
                  </h5>
                </li>
              ))}
            </ul>
          </>
        ))}
      </div>
    </div>
  );
};
